import { h, Fragment } from "preact";
import ProductOptionSwatchesGrouped from "./product-option-swatches-grouped";
import ProductOptionSwatches from "./product-option-swatches";
import ProductOptionPills from "./product-option-pills";
import ProductOptionPillsInline from "./product-option-pills-inline";
import ProductOptionSwatchesInline from "./product-option-swatches-inline";
import ProductOptionImagePills from "./product-option-image-pills";
import ProductOptionImagePillsInline from "./product-option-image-pills-inline";
import { isImagePillOption, isSwatchOption } from "./product-option-styles";
import displayableOptionValues from "./displayableOptionValues";

export default function ProductOption({
  option,
  optionNumber,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues,
  variantsByOptionValue,
  unavailableOptionValues,
  waitlistOptionValues,
  allowMaterialGroups,
  splitMadeToOrder,
  selectedIsHidden,
  selectedVariant,
  openByDefault,
  last,
  enableSwatchPreview,
  enableAccordions,
  disabledSwatchStyle,
  optionSize,
  sizeNote,
}) {
  const isSwatch = isSwatchOption(option);
  const isImagePills = isImagePillOption(option);

  const optionValues = displayableOptionValues({
    optionValues: option.optionValues,
    selectedOptionValue,
    selectedIsHidden,
  });

  if (enableAccordions) {
    if (isImagePills) {
      return (
        <ProductOptionImagePills
          optionValues={optionValues}
          optionName={option.optionName}
          optionNumber={optionNumber}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
          openByDefault={openByDefault}
          sizeNote={sizeNote}
        />
      );
    }

    if (isSwatch) {
      if (allowMaterialGroups) {
        return (
          <ProductOptionSwatchesGrouped
            optionValues={optionValues}
            optionName={option.optionName}
            optionNumber={optionNumber}
            updateOptionValue={updateOptionValue}
            selectedOptionValue={selectedOptionValue}
            disabledOptionValues={disabledOptionValues}
            variantsByOptionValue={variantsByOptionValue}
            unavailableOptionValues={unavailableOptionValues}
            waitlistOptionValues={waitlistOptionValues}
            selectedVariant={selectedVariant}
            openByDefault={openByDefault}
            enableSwatchPreview={enableSwatchPreview}
            disabledSwatchStyle={disabledSwatchStyle}
            optionSize={optionSize}
            splitMadeToOrder={splitMadeToOrder}
          />
        );
      } else {
        return (
          <ProductOptionSwatches
            optionValues={optionValues}
            optionName={option.optionName}
            optionNumber={optionNumber}
            updateOptionValue={updateOptionValue}
            selectedOptionValue={selectedOptionValue}
            disabledOptionValues={disabledOptionValues}
            variantsByOptionValue={variantsByOptionValue}
            unavailableOptionValues={unavailableOptionValues}
            waitlistOptionValues={waitlistOptionValues}
            selectedVariant={selectedVariant}
            openByDefault={openByDefault}
            enableSwatchPreview={enableSwatchPreview}
            disabledSwatchStyle={disabledSwatchStyle}
            optionSize={optionSize}
          />
        );
      }
    }

    return (
      <ProductOptionPills
        optionValues={optionValues}
        optionName={option.optionName}
        optionNumber={optionNumber}
        updateOptionValue={updateOptionValue}
        selectedOptionValue={selectedOptionValue}
        disabledOptionValues={disabledOptionValues}
        variantsByOptionValue={variantsByOptionValue}
        unavailableOptionValues={unavailableOptionValues}
        waitlistOptionValues={waitlistOptionValues}
        openByDefault={openByDefault}
        optionSize={optionSize}
        sizeNote={sizeNote}
      />
    );
  } else {
    if (isImagePills) {
      return (
        <ProductOptionImagePillsInline
          optionValues={optionValues}
          optionName={option.optionName}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
          last={last}
          sizeNote={sizeNote}
        />
      );
    }

    if (isSwatch) {
      return (
        <ProductOptionSwatchesInline
          optionValues={optionValues}
          optionName={option.optionName}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
          variantsByOptionValue={variantsByOptionValue}
          unavailableOptionValues={unavailableOptionValues}
          waitlistOptionValues={waitlistOptionValues}
          disabledSwatchStyle={disabledSwatchStyle}
          last={last}
          optionSize={optionSize}
        />
      );
    }

    return (
      <ProductOptionPillsInline
        optionValues={optionValues}
        optionName={option.optionName}
        updateOptionValue={updateOptionValue}
        selectedOptionValue={selectedOptionValue}
        disabledOptionValues={disabledOptionValues}
        variantsByOptionValue={variantsByOptionValue}
        unavailableOptionValues={unavailableOptionValues}
        waitlistOptionValues={waitlistOptionValues}
        last={last}
        optionSize={optionSize}
        sizeNote={sizeNote}
      />
    );
  }
}
